import type * as React from "react";

import { cn } from "@/lib/utils";

// Registry skeleton on the app's control tone so placeholders read as the
// wells they stand in for; reduced-motion users get a static block.
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "animate-pulse rounded-md bg-control motion-reduce:animate-none",
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
